import {
  TaskMessageResponseSource,
  TaskMessageResponseSourceType,
} from '../../graphql/schema';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDatabase, faGlobe, faTimes } from '@fortawesome/pro-light-svg-icons';
import { useSidebarLayout } from '../sidebar/SidebarLayout';
import SidebarHeader from '../sidebar/SidebarHeader';

interface Props {
  sources?: TaskMessageResponseSource[] | null;
}

const MessageSources = ({ sources }: Props) => {
  const { setRightSidebarContent } = useSidebarLayout();

  return (
    <div className="flex-col flex">
      <SidebarHeader
        title="Quellen"
        onClose={() => setRightSidebarContent(null)}
        icon={faTimes}
      />
      <div className="p-5 space-y-5 flex-1 flex flex-col overflow-y-auto">
        {sources?.map((source) => (
          <a
            className="w-full space-y-1 block"
            key={`${source.url}-${source.title}`}
            href={source.url ?? ''}
            target="_blank"
          >
            <div className="space-x-1 text-xs">
              <FontAwesomeIcon
                icon={
                  source.type ===
                  TaskMessageResponseSourceType.KNOWLEDGE_BASE_FILE
                    ? faDatabase
                    : faGlobe
                }
                size="sm"
              />
              <span>
                {source.type ===
                TaskMessageResponseSourceType.KNOWLEDGE_BASE_FILE
                  ? 'Unternehmensdaten'
                  : 'Internetseite'}
              </span>
            </div>
            {source.title && (
              <div className="font-semibold">{source.title}</div>
            )}
            {source.content && (
              <div className="text-xs text-gray-500">{source.content}</div>
            )}
          </a>
        ))}
      </div>
    </div>
  );
};

export default MessageSources;
